module.exports = __webpack_public_path__ + "img/Erdwiens_Scaled.jpg";